import { useState } from "react";
import { useNavigate } from "react-router-dom";

declare const process: { env: Record<string, string | undefined> };
const API = `${process.env.REACT_APP_BACKEND_URL}/api/pureh/blend`;

const AXES = [
  { key: "sweet", label: "حلاوة" },
  { key: "dry", label: "جفاف" },
  { key: "smoke", label: "دخان" },
  { key: "fresh", label: "انتعاش" },
  { key: "warm", label: "دفء" },
  { key: "rose", label: "وردية" },
  { key: "citrus", label: "حمضية" },
];

type Hit = { id: string; name: string; house: string; family_ar: string; dna: string; distance: number };

export default function DiscoverPage() {
  const nav = useNavigate();
  const [vals, setVals] = useState<Record<string, number>>(
    Object.fromEntries(AXES.map((a) => [a.key, 5])));
  const [hits, setHits] = useState<Hit[] | null>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const run = async () => {
    setBusy(true);
    setErr(null);
    try {
      const q = AXES.map((a) => `${a.key}=${vals[a.key]}`).join("&");
      const res = await fetch(`${API}/discover?${q}`, { credentials: "include" });
      if (!res.ok) throw new Error(String(res.status));
      setHits(await res.json());
    } catch (e: any) { setErr(String(e.message || e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl space-y-4" data-testid="discover-page">
      <div className="bl-card">
        <div className="bl-eyebrow mb-3">قرّبني من هدف — اظبط المحاور والمحرّك يرشّح أقرب 5</div>
        <div className="space-y-3">
          {AXES.map((a) => (
            <div key={a.key} className="flex items-center gap-3">
              <span className="bl-sub" style={{ width: 60 }}>{a.label}</span>
              <input type="range" min={0} max={10} step={1} value={vals[a.key]} style={{ flex: 1, accentColor: "var(--bl-gold)" }}
                onChange={(e) => setVals((p) => ({ ...p, [a.key]: Number(e.target.value) }))}
                data-testid={`discover-slider-${a.key}`} />
              <span className="bl-pill" style={{ width: 36, justifyContent: "center" }}>{vals[a.key]}</span>
            </div>
          ))}
        </div>
        <button className="bl-btn primary mt-4" onClick={run} disabled={busy} data-testid="discover-run-btn">
          {busy ? "بيدوّر…" : "🔍 رشّح الأقرب"}
        </button>
        {err && <div className="bl-sub mt-2" style={{ color: "var(--bl-danger)" }}>{err}</div>}
      </div>

      {hits && (
        <div className="space-y-2" data-testid="discover-results">
          {hits.map((h, i) => (
            <div key={h.id} className="bl-card hoverable" data-testid={`discover-hit-${h.id}`}>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="bl-pill">#{i + 1}</span>
                <span className="font-extrabold bl-en">{h.name}</span>
                <span className="bl-sub bl-en">{h.house}</span>
                <span className="bl-pill">{h.family_ar}</span>
                <span className="bl-sub">مسافة {h.distance}</span>
                <button className="bl-btn primary mr-auto" style={{ padding: "6px 16px" }}
                  onClick={() => nav(`/pureh/blend/target/${h.id}`)} data-testid={`discover-build-${h.id}`}>
                  ابنِ التركيبة ←
                </button>
              </div>
              <div className="bl-sub bl-en mt-1" style={{ fontSize: 11 }}>DNA: {h.dna}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
